export default __webpack_public_path__ + "dropbox-logo.png";